module.exports = __webpack_public_path__ + "media/images/convenios/hhhh-116494e849e621838af740fcc69b26cd.jpg";